<template>
  <div
    class="wt2-produced-page wt2-sg"
    @mousemove="onProducedMove"
    @mouseleave="onProducedLeave"
  >
    <produced-content
      :timeout-control-time="timeoutControlTime"
      :canPlay="canPlay"
      :video="video"
    ></produced-content>
  </div>
</template>

<script>
import app from 'app';
import ProducedContent from 'v/Produced/ProducedContent.vue';
import PopupActionMixin from 'mixins/PopupAction.vue';

export default app.Vue.extend({
  name: 'ProducedPage',
  mixins: [PopupActionMixin],

  provide() {
    const api = {};
    // make it reactive - like in data
    Object.defineProperty(api, 'isVideoReadyToPublish', {
      enumerable: true,
      get: () => this.isVideoReadyToPublish,
    });
    return { api };
  },

  analytics: {
    'slack:fromSlack': 'Followed Link from Slack',
  },

  components: {
    ProducedContent,
  },

  props: {
    video: {
      type: Object,
      required: true,
    },
    canPlay: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isVideoReadyToPublish: null,
    };
  },

  created() {
    const url = location.search;
    const regex = new RegExp('slk=\\w+');
    const fromSlack = regex.test(url);

    if (fromSlack) {
      const match = url.match(regex);
      const type = match && match[0] && match[0].split('=');

      this.isVideoReadyToPublish =
        _.every(app.programmers.toJSON(), (p) => {
          return (p && p.id) !== this.video.programmerId;
        }) ||
        (type && type.length >= 2 && type[1] === 'ready_to_publish');

      const source = this.video.template
        ? 'Storyboards'
        : this.isVideoReadyToPublish
        ? 'Ready-to-publish'
        : 'Produced';

      this.$triggerAnalytics('slack:fromSlack', {
        LandingPage: source,
      });
    }
  },

  watch: {
    getMastHeadVisibleStatus(status) {
      const onToggleMasthead = this.$options.onToggleMasthead;
      onToggleMasthead && onToggleMasthead(status);
    },
  },

  methods: {
    // @override
    onProducedLeave(e) {
      this.cancelMastHeadTimeout();
      const belowHeader = e.offsetY > 50;

      if (this.isPlaying && belowHeader) {
        this.hideMastHead();
      }
    },
  },
});
</script>
